// extracted by mini-css-extract-plugin
export default {"default":"lePE","primary":"_3Q9Q","success":"Lzdz","danger":"_3XHg","violet":"_2xXO","light":"_15nf","text":"PWFq","smallSize":"BFBF","elevation0":"l7-z","elevation1":"_3Qr_"};